module.exports = __webpack_public_path__ + "assets/img/menu-news.a85feff0.svg";